<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageClasse
          id="finderClasse"
          v-model="form.classe"
          label="Classe:"
          required
          :prefix="prefix + title"
          :isModal="true"
          @onselect="handle"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import LgFinderPageClasse from "@/components/Finders/LgFinderPageClasse.vue";

export default {
  components: {
    LgFinderPageClasse,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        classe: null,
      },
      prefix: "Configuração do Sistema",
      title: "Classe",
    };
  },
  methods: {
    handle(classe) {
      this.form.classe = classe;
    },
    async salvar() {
      if (!this.form.classe) {
        this.$bvToast.toast("Selecione uma classe", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = this.form.classe.id.toString();

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        this.form.classe = {
          id: parseInt(this.configuracao.valorPropriedade),
          descricao: this.configuracao.classeLabel,
        };
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
